module.exports = __webpack_public_path__ + "media/images/front/sp/dummy/ranking01-821a8bf10e500597fac270823b2daede.jpg";